import React from "react";
import { BarChart3, Users, Clock, TrendingUp } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import ProducaoFilters from "./components/ProducaoFilters";
import RankingProducao from "./components/RankingProducao";
import EstatisticasPizzas from "./components/EstatisticasPizzas";
import EstatisticasBordas from "./components/EstatisticasBordas";
import StatCard from "./components/StatCard";
import {
  EstatisticasProducaoProvider,
  useEstatisticasProducao,
} from "./context/EstatisticasProducaoContext";
import { producaoService } from "../../../services/producaoService";

const EstatisticasProducaoContent: React.FC = () => {
  const {
    startDate,
    endDate,
    selectedLojaId,
    selectedUsuarioId,
    setStartDate,
    setEndDate,
    setSelectedLojaId,
    setSelectedUsuarioId,
    handleApplyFilter,
    lojaOptions,
    usuarioOptions,
    appliedFilters,
    usuariosProducao,
    isFetchingProducao,
  } = useEstatisticasProducao();

  const { data: resumo } = useQuery({
    queryKey: ["producao-resumo", appliedFilters],
    queryFn: () =>
      producaoService.getResumo({
        dataInicio: appliedFilters.dataInicio,
        dataFim: appliedFilters.dataFim,
        lojaId: appliedFilters.lojaId,
      }),
    enabled: !!(appliedFilters.dataInicio && appliedFilters.dataFim),
  });

  const totalProducoes = usuariosProducao.reduce(
    (acc, user) => acc + user.quantidadeProducoes,
    0
  );
  const totalUsuarios = usuariosProducao.length;
  const tempoMedio =
    usuariosProducao.length > 0 ? usuariosProducao[0].tempoMedio : "00:00:00";
  const emProducao = resumo?.totalProducoesEmAndamento || 0;

  return (
    <div className="space-y-6">
      <ProducaoFilters
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={setStartDate}
        onEndDateChange={setEndDate}
        lojas={lojaOptions}
        selectedLojaId={selectedLojaId}
        onLojaChange={setSelectedLojaId}
        usuarios={usuarioOptions}
        selectedUsuarioId={selectedUsuarioId}
        onUsuarioChange={setSelectedUsuarioId}
        onApplyFilter={handleApplyFilter}
        isLoading={isFetchingProducao}
      />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        <StatCard
          icon={BarChart3}
          label="Produções Finalizadas"
          value={totalProducoes}
        />
        <StatCard icon={Users} label="Pizzaiolos" value={totalUsuarios} />
        <StatCard icon={Clock} label="Tempo Médio" value={tempoMedio} />
        <StatCard icon={TrendingUp} label="Em Produção" value={emProducao} />
      </div>
      <RankingProducao />
      <EstatisticasPizzas />
      <EstatisticasBordas />
    </div>
  );
};

const EstatisticasProducao: React.FC = () => {
  return (
    <EstatisticasProducaoProvider>
      <EstatisticasProducaoContent />
    </EstatisticasProducaoProvider>
  );
};

export default EstatisticasProducao;
